import React from 'react';
import {Router, Switch, Route} from 'react-router-dom';
import {createBrowserHistory} from 'history';
import './App.css';
import 'tailwindcss/tailwind.css';
const Landing = React.lazy(() => import('./pages/Landing'));
const Home = React.lazy(() => import('./pages/Home'));
const Blog = React.lazy(() => import('./pages/Blog'));
const About = React.lazy(() => import('./pages/About'));
const Error404 = React.lazy(() => import('./pages/Error404'));
const NavBar = React.lazy(() => import('./components/NavBar'));
const Projects = React.lazy(() => import('./pages/Projects'));
const PokemonInfoApp = React.lazy(() => import('./pages/PokemonInfoApp'));
const history = createBrowserHistory();

const App: React.FC = () => {
  return (
    <div className="App">
      <Router history={history}>
        <div>
          <NavBar />
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/landing" component={Landing} />
            <Route exact path="/projects/" component={Projects} />
            <Route
              exact
              path="/projects/pokemon-info-app"
              component={PokemonInfoApp}
            />
            <Route exact path="/Blog" component={Blog} />
            <Route exact path="/About" component={About} />
            <Route component={Error404} />
          </Switch>
        </div>
      </Router>
    </div>
  );
};

export default App;
